<template>
  <div class="journal-container">
    <section class="w1200 flex">
      <template v-if="loading || leftData.length > 0">
        <subject-list-skeleton v-if="loading && leftData.length === 0" variant="filter" />
        <subject-left-menu v-else :leftData="leftData" :showLetterFlag="showLetter" :delName="delName" :delSourceFrom="delSource" :delAll="delAll" @childByValue="childByValue" @sourceByValue="sourceByValue"></subject-left-menu>
      </template>
      <!-- 右侧列表 -->
      <div class="right-list">
        <div class="right-top">
          <p class="filter">
            筛选条件：
            <label v-for="(item, index) in conData" :key="index" class="flex">
              {{ item.fatherName }}: {{ item.name }}
              <i class="el-icon-close" @click="delName = item"></i>
            </label>
          </p>
          <div class="total">
            共<label>{{ listTotal }}</label
            >条记录
            <!-- <p>
              排序：
              <el-select v-model="sortVal" @change="handleSearchSort" placeholder="请选择">
                <el-option v-for="item in sortList" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </p> -->
            <div class="search">
              <el-input v-model="searchWords" placeholder="请输入检索词" style="flex: 1" @keyup.enter.native="toSearch" clearable></el-input>
              <span class="search_img" @click="toSearch">
                <img src="../../assets/images/search_icon.png" />
              </span>
            </div>
          </div>
        </div>
        <div class="right-item">
          <subject-list-skeleton v-if="loading" variant="journal" />
          <ul v-else>
            <li class="flex" v-for="(item, index) in list" :key="index">
              <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
              <div class="img" @click="toDetail(item.sid)">
                <img :src="item.cover ? imgUrl + item.cover : defaultImg" />
              </div>
              <div class="right-info">
                <p v-if="item.name" @click="toDetail(item.sid)">
                  <span v-safe-html="item.name"></span>
                  <!-- oa去除馆藏标识 -->
                  <!-- <img v-if="item.isLibrary == 1 && pzType != 'oa'" src="../../assets/images/icon-gc.png" /> -->
                </p>
                <p v-if="item.issn">ISSN：<span v-safe-html="item.issn"></span></p>
                <p v-if="item.aliasName">其他刊名：<span v-safe-html="item.aliasName"></span></p>
                <!-- <p v-if="item.pissn">PISSN: <span v-safe-html="item.pissn"></span></p>
                <p v-if="item.eissn">EISSN: <span v-safe-html="item.eissn"></span></p> -->
                <p v-if="item.publisherName">出版社：<span v-safe-html="item.publisherName"></span></p>
                <p class="yinzi" v-if="item.effectScore">
                  影响因子：<span>{{ item.effectScore }}</span>
                </p>
              </div>
            </li>
          </ul>
          <div class="noData" v-if="total <= 0 && !loading">
            <el-empty description="暂无数据"></el-empty>
          </div>
          <div class="subject-page">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SubjectLeftMenu from "@/components/SubjectLeftMenu.vue";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";
import { EventBus } from "../../utils/eventBus";
import baseUrlConfig from "../../api/baseurl.js";
export default {
  data() {
    return {
      loading: true,
      conData: [], //条件的过滤
      filterData: [],
      leftData: [],
      showLetter: true,
      delName: null,
      pageSize: 10,
      pageNo: 1,
      listTotal: 0,
      total: 0,
      searchObj: null,
      list: [],
      imgUrl: baseUrlConfig.fileUrl || "",
      defaultImg: require("../../assets/images/default.png"),
      searchWord: "",
      searchArray: [],
      delAll: 0,
      pzType: "",
      sourceList: [],
      delSource: 0,
      searchWords: "",
      search: {
        value: 1,
        options: [
          {
            value: 1,
            label: "分词检索",
          },
          {
            value: 2,
            label: "智能检索",
          },
        ],
        searchPaperOptions: [
          { label: "全部", value: null },
          { label: "刊名", value: "name" },
          { label: "ISSN", value: "issn" },
          { label: "出版社", value: "publisherName" },
        ],
        selectVal: null,
        keyword: "",
      },
      sortList: [
        {
          value: "_score",
          label: "相关度",
        },
        // {
        //   value: "year",
        //   label: "年份",
        // },
      ],
      sortVal: "_score",
    };
  },
  components: { SubjectLeftMenu, SubjectListSkeleton },
  beforeDestroy() {
    SubjectLeftMenu; // 组件销毁前移除事件监听，避免重复注册
    EventBus.$off("submitSubject");
  },

  mounted() {
    this.imgUrl = baseUrlConfig.fileUrl || "";
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let id = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        this.getSubjectId(id);
      }
    }, 300);

    EventBus.$on("submitSubject", id => {
      // 标记数据已加载
      this.getSubjectId(id);
    });
  },
  methods: {
    // 搜索
    toSearch() {
      this.pageNo = 1;
      this.search.keyword = this.searchWords;
      this.getList();
    },
    getSubjectId(id) {
      console.log(id);
      window.clearInterval(this.timer);
      this.subjectId = id;
      this.getList();
    },
    getList() {
      this.loading = true;
      let array = [];

      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
          type: element.fatherName == "资源来源" ? "metric" : null,
        });
      });
      // 写死 的 资源来源过滤
      if (typeof config !== "undefined" && config && config.type == "oa") {
        array.push({
          filterField: "oaType",
          filterValue: ["20"],
          type: "metric",
        });
      }

      let postBody = {
        searchWord: this.search.keyword,
        searchFields: this.search.selectVal ? this.search.selectVal.split(",") : [],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.sortVal,
        orderType: "DESC",
        metricFilterList: array,
        paramList: JSON.parse(sessionStorage.getItem("heightSearchWord")),
        sourceList: this.sourceList.length > 0 ? this.sourceList : [],
        subjectId: this.subjectId,
      };

      this.$http({
        url: "api/v1/reception/journal/list",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;
        this.list = res.data.recordList;
        res.data.left.forEach(element => {
          //默认展开 显示全部  否则默认显示5条记录
          if (element.name == "核心期刊" || element.name == "学科分类") {
            element.drop = true;
            element.dropNum = element.items.length;
          } else {
            element.dropNum = 5;
          }
        });
        this.leftData = res.data.left;
        this.delSource = 0;
      });
    },
    childBySearch(val) {
      sessionStorage.removeItem("heightSearchWord");
      this.delAll++;
      this.conData = [];
      this.filterData = [];
      this.searchArray = [];
      this.searchWord = val.keyword;
      this.searchFields = val.selectVal;
      this.pageNo = 1;
      this.loading = true;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    childByValue(val) {
      this.pageNo = 1;
      this.conData = val.filterArray;
      this.filterData = val.newNarr;
      this.getList();
    },
    // 资源来源
    sourceByValue(val) {
      this.loading = true;
      this.pageNo = 1;
      this.sourceList = val;
      this.getList();
    },
    toDetail(sid) {
      const { href } = this.$router.resolve({
        path: `/homeDetail`,
        query: { sid: sid },
      });
      window.open(href, "_self");

      // this.$router.push({ path: "homeDetail", query: { id: id } });
    },
    // 跳转高级检索
    toHightSearch() {
      this.$router.push({ path: "/search", query: { type: "home" } });
    },
    // 排序
    handleSearchSort() {
      this.pageNo = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.journal-container {
  width: calc(100% - 40px);
  max-width: 1300px;
  min-width: 0;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  padding-bottom: 20px;
  box-sizing: border-box;
  .w1200 {
    margin-top: 20px;
    width: 100%;
    min-width: 0;
  }
  .right-list {
    flex: 1;
    min-width: 0;
    .right-top {
      background: #fff;
    }
    .filter {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #eeeeee;
      line-height: 29px;
      gap: 10px;
      .searchword {
        margin-right: 20px;
        label {
          color: #63ace5;
        }
      }
      .flex {
        display: inline-block;
        border: 1px solid #cccccc;
        color: #63ace5;
        font-size: 14px;
        padding: 0 10px;
        height: 30px;
        i {
          margin-left: 5px;
          font-size: 12px;
          color: #999999;
          cursor: pointer;
        }
      }
    }
    .total {
      padding: 15px;
      color: #666666;
      display: flex;
      align-items: center;
      label {
        color: #e40000;
        margin: 0 3px;
      }
      p {
        margin-left: auto;
        ::v-deep .el-input__inner {
          width: 140px;
          border: none;
          background: #f7f7f7;
        }
      }
      .search {
        background: #fff;
        border: 1px solid #cccccc;
        width: min(400px, 100%);
        position: relative;
        display: flex;
        align-items: center;
        margin-left: auto;
        ::v-deep .el-input__inner {
          border: none;
          border-radius: 0;
          height: 30px;
          line-height: 30px;
        }
        ::v-deep .el-input__icon {
          line-height: 30px;
        }
        .el-input {
          flex: 1;
        }

        .search_img {
          width: 40px;
          height: 30px;
          background: #2c5f97;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
    .right-item {
      background: #fff;
      margin-top: 10px;
      padding: 0 20px;
      min-height: 400px;
      ul {
        li {
          padding: 20px 0;
          border-bottom: 1px dashed #eeeeee;
          .index {
            width: 50px;
          }
          .img {
            width: 160px;
            height: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            border: 1px solid #eeeeee;
            cursor: pointer;
            margin-right: 20px;
            cursor: pointer;
            img {
              max-width: 158px;
              max-height: 158px;
            }
          }
          .right-info {
            color: #666666;
            flex: 1;
            min-width: 0;
            position: relative;
            p {
              line-height: 25px;
              font-size: 14px;
              &:nth-of-type(1) {
                color: #333;
                font-size: 16px;
                font-weight: 400;
                margin-bottom: 10px;
                cursor: pointer;
              }
              img {
                margin-left: 10px;
                height: 22px;
                vertical-align: -6px;
              }
            }
            .yinzi {
              position: absolute;
              bottom: 0;
              left: 0;
              font-size: 14px;
              span {
                color: #45c1c3;
              }
            }
          }
          &:hover {
            .right-info {
              p {
                &:nth-of-type(1) {
                  background-image: linear-gradient(to right, #006eb3, #63ace5);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  // color: #63ace5;
                }
              }
            }
          }
        }
      }
    }
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #63ace5;
    border-color: #63ace5;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #63ace5;
  }
  ::v-deep .el-checkbox__inner:hover,
  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #63ace5;
  }
  ::v-deep .el-pager li.active,
  ::v-deep .el-pager li:hover,
  ::v-deep .el-select .el-input.is-focus .el-input__inner,
  ::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
    color: #63ace5;
    border-color: #63ace5;
  }
  ::v-deep .el-pager li:hover {
    color: #63ace5;
  }
  ::v-deep .el-pagination button:hover {
    color: #63ace5;
  }
  ::v-deep .el-pagination__jump .el-input__inner:focus {
    border-color: #63ace5;
  }
}

@media (max-width: 1024px) {
  .journal-container {
    .w1200 {
      display: flex;
      flex-direction: column;
    }

    .right-list .total {
      flex-wrap: wrap;
      gap: 12px;

      .search {
        flex: 1 1 320px;
      }
    }
  }
}

@media (max-width: 768px) {
  .journal-container {
    width: calc(100% - 24px);

    .w1200 {
      margin-top: 12px;
    }

    .right-list {
      .filter,
      .total {
        padding: 12px;
      }

      .total .search {
        flex-basis: 100%;
        width: 100%;
        margin-left: 0;
      }

      .right-item {
        padding: 0 12px;

        ul li {
          position: relative;
          align-items: flex-start;
          flex-wrap: wrap;
          padding: 16px 0;

          .index {
            width: 28px;
          }

          .img {
            width: 100px;
            height: 120px;
            margin-right: 12px;

            img {
              max-width: 98px;
              max-height: 118px;
            }
          }

          .right-info {
            flex: 1 1 calc(100% - 140px);

            .yinzi {
              position: static;
              margin-top: 8px;
            }
          }
        }
      }
    }

    ::v-deep .el-pagination {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      row-gap: 8px;
      padding: 16px 0;
      white-space: normal;
    }
  }
}
</style>
